import axios from 'axios';
import { API } from '../../../config/api';

const http = axios.create({
  baseURL: API.BACKEND,
  timeout: 10000
});

// `axios.create()` snapshots the global defaults, so a token written later by
// `setAuthToken` never reaches this instance. See features/jobs/api/http.js.
http.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['x-auth-token'] = token;
  }
  return config;
});

export async function fetchExecutionLogs({
  machineId,
  phase,
  dateFrom,
  dateTo,
  page = 1,
  limit = 25
} = {}) {
  const params = { page, limit };
  if (machineId) params.machineId = machineId;
  if (phase) params.phase = phase;
  if (dateFrom) params.dateFrom = dateFrom;
  if (dateTo) params.dateTo = dateTo;

  const { data } = await http.get('/api/v1/execution-logs', { params });
  return data;
}

export async function fetchMachineExecutionLogs(machineId, { phase, dateFrom, dateTo, page = 1, limit = 25 } = {}) {
  const params = { page, limit };
  if (phase) params.phase = phase;
  if (dateFrom) params.dateFrom = dateFrom;
  if (dateTo) params.dateTo = dateTo;

  const { data } = await http.get(`/api/v1/execution-logs/machine/${machineId}`, { params });
  return data;
}

export async function fetchJobExecutionLogs(jobId) {
  const { data } = await http.get(`/api/v1/execution-logs/job/${jobId}`);
  return data;
}

export async function updateExecutionLog(id, body) {
  const { data } = await http.patch(`/api/v1/execution-logs/${id}`, body);
  return data;
}

export async function fetchExecutionLogsSummary({ dateFrom, dateTo } = {}) {
  const params = {};
  if (dateFrom) params.dateFrom = dateFrom;
  if (dateTo) params.dateTo = dateTo;

  const { data } = await http.get('/api/v1/execution-logs/summary', { params });
  return data;
}
